module.exports = __webpack_public_path__ + "static/media/EHS-Handling-of-service-users-money-protected.89f552d9.pdf";